module.exports = __webpack_public_path__ + "static/media/bfd.93222a59.png";